import { additionalDefaultValues } from "./FormGroups/AdditionalFormGroup";
import { documentDefaultValues } from "./FormGroups/DocumentFormGroup";
import { descriptionDefaultValues } from "./FormGroups/DescriptionFormGroup";
import { deadlineDefaultValues } from "./FormGroups/DeadlineFormGroup";
import { estimateDefaultValues } from "./FormGroups/EstimateFormGroup";
import { contractDefaultValues } from "./FormGroups/ContractFormGroup";

export const defaultValues = {
  ...documentDefaultValues,
  ...descriptionDefaultValues,
  ...deadlineDefaultValues,
  ...estimateDefaultValues,
  ...contractDefaultValues,
  ...additionalDefaultValues
};
